import * as React from 'react';
import {QueryResults, useMediaQueries} from '../../d6/hooks/useMediaQueries';

const MediaQueryContext = React.createContext<QueryResults | null>(null);

interface MediaQueryContextProps {
    children: React.ReactNode;
}

export function MediaQueryContextProvider({
    children
}: MediaQueryContextProps): JSX.Element {
    const mediaQueries = useMediaQueries();

    return (
        <MediaQueryContext.Provider value={mediaQueries}>
            {children}
        </MediaQueryContext.Provider>
    );
}
